import React from 'react'
import {makeStyles, ThemeProvider} from '@material-ui/core'
import CssBaseline from '@material-ui/core/CssBaseline'
import {Provider} from 'react-redux'
import {BrowserRouter as Router, Route, Switch, useLocation} from 'react-router-dom'
import Registration from './components/Registration'
import Authorization from './components/Registration/Authorization'
import Splash from './components/Splash'
import {store} from './store'
import theme from './theme'
import Welcome from './components/Welcome'
import SignIn from './components/SignIn'
import Forgot from './components/Forgot'
import ResetPassword from './components/ResetPassword'
import Step from './components/Step'
import {registerDevice} from './services/api'
import {useState} from 'react'
import {IRegisterDeviceRequestParams} from './interfaces/api'
import Confirmation from './components/Registration/Confirmation'
import PrivacyPolicy from './components/PrivacyPolicy'
import TermsCondition from './components/TermsCondition'

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100vh',
        margin: 'auto 0',
    },
}))

function App() {
    const classes = useStyles()

    const [deviceInfo] = useState<IRegisterDeviceRequestParams>({
        model: '',
        type: 'web',
        os: '1.0.1',
    })

    const handleDevice = async () => {
        let deviceId = sessionStorage.getItem('device') || undefined
        //TODO can't we do if (!deviceId)?

        if (deviceId === undefined) {
            console.info('Device not found, registering new device.')
            const newDevice = await registerDevice(deviceInfo)
            if (newDevice.data.id) {
                deviceId = newDevice.data.id
                console.info('new device ID generated', newDevice.data.id)
            }
        }
        if (deviceId === undefined) throw Error('Device ID busted')
        console.info(`Retrieve device from ID ${deviceId}`)
        sessionStorage.setItem('device', deviceId)
    }

    React.useEffect(() => {
        handleDevice()
    })
    return (
        <main className={classes.root}>
            <Provider store={store}>
                <CssBaseline/>
                <Router>
                    <ThemeProvider theme={theme}>
                        <Switch>
                            <Route path={'/privacy-policy'}>
                                <PrivacyPolicy/>
                            </Route>
                            <Route path={'/terms-conditions'}>
                                <TermsCondition/>
                            </Route>
                            <Route path={'/confirmation'}>
                                <Confirmation/>
                            </Route>
                            <Route path={'/register'}>
                                <Registration/>
                            </Route>
                            <Route path={'/authorization/register'}>
                                <Authorization/>
                            </Route>
                            <Route path={'/signin'}>
                                <SignIn/>
                            </Route>
                            <Route path={'/forgot'}>
                                <Forgot/>
                            </Route>
                            <Route path={'/resetpassword'}>
                                <ResetPassword/>
                            </Route>
                            <Route path={'/welcome'}>
                                <Welcome/>
                            </Route>
                            <Route
                                path="/step"
                                render={(props: any) => {
                                    return <Step user={props.user} device={props.device}/>
                                }}
                            ></Route>
                            <Route path={'/'}>
                                <Splash timeout={2000} sendTo="/welcome"/>
                            </Route>
                        </Switch>
                    </ThemeProvider>
                </Router>
            </Provider>
        </main>
    )
}

export default App
